import noUiSlider from 'nouislider'; // eslint-disable-line import/extensions
import 'nouislider/distribute/nouislider.min.css';
import sliderUtils from './utils';

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    onChange: {
      type: Function,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    decimals: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
    },
    suffix: {
      type: String,
    },
  },

  data() {
    return {
      internalValue: this.value,
    };
  },

  methods: {
    isValueNaN(val) {
      return Number.isNaN(parseFloat(val));
    },
  },

  beforeMount() {
    if (this.isValueNaN(this.value)) {
      this.internalValue = 0;
    }
  },

  mounted() {
    const { slide } = this.$refs;

    noUiSlider.create(slide, {
      start: [this.internalValue],
      range: {
        min: this.min,
        max: this.max,
      },
      step: this.step || undefined,
      tooltips: [true],
      connect: [true, false],
      format: {
        to: value => `${value.toFixed(this.decimals)}${this.suffix || ''}`,
        from: value => value,
      },
    });

    slide.noUiSlider.on('update', sliderUtils.correctLimits);

    slide.noUiSlider.on('end', (value) => {
      if (!this.step) {
        slide.noUiSlider.set(value);
      }
    });

    slide.noUiSlider.on('set', (value) => {
      let proccesedValue = parseFloat(value[0]);

      if (this.isValueNaN(proccesedValue)) {
        proccesedValue = 0;
      }

      sliderUtils.correctLimits();
      this.internalValue = proccesedValue;
      this.onChange(this.internalValue);
    });

    if (this.isDisabled) {
      slide.setAttribute('disabled', true);
    }

    sliderUtils.cacheReferences(
      this.$refs.slide.querySelector('.noUi-tooltip'),
      this.$refs['c-input-slide'],
    );
  },

  update() {
    this.internalValue = this.value;
  },

  beforeDestroy() {
    const { slide } = this.$refs;

    slide.noUiSlider.off('update');
    slide.noUiSlider.off('set');
    slide.noUiSlider.destroy();
  },
};
